import {ApiClass} from "./ApiClass";
import {API_URL} from "../../constants/CONST";


class FastailyApiClass extends ApiClass {

    async getTextFastaily(): Promise<string[]> {
        try {
            const res = await fetch(API_URL + "/fastaily/text", {
                method: "GET",
                headers: this.jsonHeader
            })

            const data = await res.json()
            return data.text.map((element: string) => {
                return element.charAt(0).toLowerCase() + element.slice(1);
            })
        } catch (e) {
            return []
        }
    }

    async hasUserParticipatedToday(userId: number, gameModeId : number): Promise<{
        id?: number,
        score?: number,
        date?: string,
        rank?: number
    }> {
        try {
            const res = await fetch(`${API_URL}/fastaily/hasUserParticipatedToday/${userId}/${gameModeId}`, {
                method: "GET",
                headers: this.jsonHeader
            });

            return await res.json();
        } catch (e) {
            return {};
        }
    }

}

export const FastailyApi = new FastailyApiClass();